import { graphql } from '@/gql';
import type { PartnerCallLogStatsQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const getPartnerCallLogStats = async ({ partnerCodeName, startDate, endDate }: PartnerCallLogStatsQueryVariables) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      partnerCodeName,
      startDate,
      endDate,
    },
    query: graphql(`
      query PartnerCallLogStats($partnerCodeName: String!, $startDate: String!, $endDate: String!) {
        partnerCallLogStats(partnerCodeName: $partnerCodeName, startDate: $startDate, endDate: $endDate) {
          totalCalls
          totalCallDuration
          avgHoldTime
        }
      }
    `),
  });

  return response.data.partnerCallLogStats;
};
